<template>
    <div
        class="d-inline-flex align-items-center flex-nowrap ps-1"
        v-if="(category?.Name ?? '') !== ''"
    >
        <InputBool
            v-model="useExternalCategory"
            class="me-2"
            v-if="showCheckbox"
        />
        {{ category?.Name }}
    </div>
</template>

<script setup lang="ts">
import { useEventCommonStoreRef } from '@/stores';
import { computed, ref } from 'vue';
import type { RaceContestantDetailsExternalData } from '@/objects/RaceContestantDetailsExternalData';
import InputBool from '../Basic/InputBool.vue';

const { Categories } = useEventCommonStoreRef();

const props = defineProps<{
    /**
     * The emit ID to display
     */
    value: number | null;

    /**
     * The full row object
     */
    row: RaceContestantDetailsExternalData;
}>();

const internalValue = ref<RaceContestantDetailsExternalData>(props.row);

// We only show the checkbox if the category values are different
const showCheckbox = computed(() => {
    return props.row.RaceContestantDetails.CategoryName != props.row.RegisteredCategoryName;
});

// we need a writable computed for the internalvalue.UseExternalCategory
const useExternalCategory = computed({
    get: () => !internalValue.value.UseExternalCategory,
    set: (value: boolean) => {
        internalValue.value.UseExternalCategory = !value;
    },
});

const category = computed(() => {
    if (!props.value) return null;

    return Categories.value.find((c) => c.ID === props.value) ?? null;
});
</script>
